<template>
    <div class="right-body" id="home" @contextmenu.prevent="">
        <div v-show="clouds.length" style="width:100%;height:100%;">
            <div class="right-middle home-middle" v-show="false">
                <button class="home-button" @click="toAddCloudPage()"><div class="icon addCloudIcon"></div>{{$t('language.common.addCloud')}}</button>
                <button class="home-button" @click="toAddEmailPage()"><div class="icon addEmailIcon" style="margin-top: 6px;"></div>{{$t('language.common.addEmail')}}</button>
            </div>
            <div class="right-cont-body right-cont-body-home">
                <div class="home-box" id='homeBox'>
                    <el-scrollbar style="height:100%;">
                    <div class="home-clouds-up" :style="{height:Math.ceil((drivesUp.length)/4)*81+'px'}">
                        <div class="cloud-box" :title="showInfo(item)" @mouseenter="hoverCurrent=index" @mouseleave="hoverCurrent=-1" :class="indexCurrent==index?'cloud-click ':''" @click="indexCurrent=index,downIndexCurrent=-1" :key="index" v-for="(item,index) in drivesUp" @dblclick="toCloudCatalog(item)" @contextmenu.prevent="editDriveMenushow($event,index,item,'up')">
                            <div class="cloud-box-left">
                                <div class="icon  home-cloud-position" :class="item.appName+'-small'"></div>
                            </div>
                            <div class="cloud-box-right">
                                <div class="right-info">
                                    <div class="name-outer">
                                        <div class="drive-bold-name" ref=driveName><span>{{item.name}}</span></div>
                                        <div class="home-outclass" ref="inputName">
                                            <input class="home-task-edit" v-model="item.inputValue" @focus="isflage=true" @blur="submitDriveName(item,index)" />
                                            <span class="home-edit-icon">
                                                <i class="icon-util name-sure" @click.stop='submitDriveName(item,index)'></i>
                                                <i class="icon-util name-cancel " @mousedown.stop='cancelEditDriveName(item,index)'></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="drive-progrss-box">
                                        <div :class="(item.driveInfo.usedSpace/item.driveInfo.totalSpace)*100>90?'drive-red-progress':'drive-progrss'" :style="{width:((item.driveInfo.usedSpace / analyzeTotalSpace(item))*100)+'%'}">
                                        </div>
                                    </div>
                                    <div class="drive-capacity">
                                        <span v-if="item.isRotate||(!item.haveLoad&&!item.driveInfo.totalSpace&&!item.isRotate)">{{$t('language.common.load')}}</span>
                                        <span v-if="!item.isRotate&&item.driveInfo.totalSpace">{{item.driveInfo.usedSpace|formatByte}}/{{item.driveInfo.totalSpace|formatByte}}</span>
                                        <span v-if="!item.driveInfo.totalSpace&&!item.isRotate&&item.haveLoad">{{$t('language.common.failed')}}</span>
                                    </div>
                                </div>
                                <div class="icon-util cloud-refresh home-refresh-position" @click="getDriveInfo(item)" :class="[!item.isRotate?'rotate':'rotate1']"></div>
                            </div>
                        </div>
                    </div>
                    <div class="hr" v-if='drivesDown.length'></div>
                    <div class="home-clouds-down" :style="{height:Math.ceil((drivesDown.length)/7)*81+'px'}">
                        <div class="home-cloud" :key="index" v-for="(item,index) in drivesDown" @dblclick="toCloudCatalog(item)" :class="downIndexCurrent==index?'cloud-click ':''" @click="downIndexCurrent=index,indexCurrent=-1" @contextmenu.prevent="editDriveMenushow($event,index,item,'down')">
                            <div class="add-cloud-item" :title="showInfo(item)">
                                <div class="icon  cloud-position" :class="item.appName+'-small'"></div>
                                <div class="drive-down">
                                    <div class="drive-down-name" ref=driveDownName>{{item.name}}</div>
                                    <div class="home-down-outclass" ref="inputDownName">
                                        <input class="home-task-edit" v-model="item.inputValue" @focus="isflage=true" @blur="submitDriveName(item,index)" />
                                        <span class="home-edit-icon">
                                            <i class="icon-util name-sure" @click.stop='submitDriveName(item,index)'></i>
                                            <i class="icon-util name-cancel " @mousedown.stop='cancelEditDriveName(item,index)'></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="edit-drives-menus" style="position: absolute;" v-show='editHomeShow' id="editHomeMenus" v-clickoutside="editHomeMenuClose">
                        <div class="edit-drive-menu" @click.stop="editDriveName()">
                            <div class="new-position rename edit-drive-position"></div>
                            <div style="float:left;">{{$t('language.common.rename')}}</div>
                        </div>
                        <div class="edit-drive-menu" @click.stop="rewriteDrive()">
                            <div class="icon-util edit-small edit-drive-position"></div>
                            <div style="float:left;">{{$t('language.leftBanner.edit')}}</div>
                        </div>
                        <div class="edit-drive-menu" @click.stop="removeDialogShow()">
                            <div class="new-position delete edit-drive-position"></div>
                            <div style="float:left;">{{$t('language.leftBanner.remove')}}</div>
                        </div>
                        <div class="edit-drive-menu" @click.stop="propertiesDialogShow()">
                            <div class="new-position properties edit-drive-position"></div>
                            <div style="float:left;">{{$t('language.common.properties')}}</div>
                        </div>
                    </div>
                    </el-scrollbar>
                </div>
                <div class="selectInfo-footer">
                    <div class="select-Info">Clouds:{{drivesUp.length+drivesDown.length-ftpArr.length-webDav.length}}</div>
                    <div class="select-Info">FTP:{{ftpArr.length}}</div>
                    <div class="select-Info">WebDAV:{{webDav.length}}</div>
                    <div class="icon scaling-open scaling-open-position" v-show="snapTaskIconShow" @click="snapTasksOpen()">
                        <snapTaskDialog ref="snapTaskDialog" @cancel='cancelUpload($event)'></snapTaskDialog>
                    </div>
                </div>
            </div>
            <propertiesDialog ref="propertiesDialog" :cloudName=cloudName :cloudId=cloudId :cloud=cloud></propertiesDialog>
            <removeDialog ref="removeDialog" :cloudId=cloudId></removeDialog>
            <editCloudDialog ref="editCloudDialog" :cloudType=cloudName :cloudId=cloudId></editCloudDialog>
            <editFtpDialog ref="editFtpDialog"></editFtpDialog>
        </div>
        <homeAddDrive v-show="!clouds.length" @addCloud="toAddCloudEmailPage()"></homeAddDrive>
        <detailedProgrssDialog ref="detailedProgrss"></detailedProgrssDialog>
        <retryFailedDialog ref="retryFailedDialog"></retryFailedDialog>
        <cancelAllDialog ref="cancelAllDialog"></cancelAllDialog>
        <editNasDialog ref="editNasDialog"></editNasDialog>
    </div>
</template>
    
    <script>
    import detailedProgrssDialog from '@/components/popup/cloud_exploer_popups/detailed_progress_popup';
    import snapTaskDialog from "@/components/popup/cloud_exploer_popups/snap_task_popup";
    import propertiesDialog from "@/components/popup/add_cloud_popups/properties_popup";
    import removeDialog from "@/components/popup/add_cloud_popups/remove_popup";
    import commonUtils from "@/js/workspace/common_util.js";
    import editCloudDialog from "@/components/popup/add_cloud_popups/edit_cloud_popup";
    import taskListUtils from "@/js/workspace/task_list_util.js";
    import commonstate from '@/js/constant.js';
    import editFtpDialog from '@/components/popup/add_cloud_popups/edit_ftp_popup';
    import retryFailedDialog from "@/components/popup/cloud_exploer_popups/retry_detailProgress_failed_popup";
    import cancelAllDialog from '@/components/popup/cloud_exploer_popups/cancel_all_popup.vue';
    import editNasDialog from '@/components/popup/add_cloud_popups/edit_nas_popup';
    import addCloudUtils from "@/js/workspace/add_cloud_utils.js";
    import homeAddDrive from "@/components/workspace/home_add_drive";
    export default {
        components: {
            propertiesDialog,
            removeDialog,
            editCloudDialog,
            editFtpDialog,
            snapTaskDialog,
            detailedProgrssDialog,
            retryFailedDialog,
            cancelAllDialog,
            editNasDialog,
            homeAddDrive,
        },
        data() {
            return {
                isRotate: true,
                drivesUp: [],
                drivesDown: [],
                noSpace: ['aDrive', 'alfresco', 'amazonS3', 'wasabi','iDrivee2','cubby', 'cloudMe', 'gSuiteSharedDrive','flickr', 'FTP', 'googlePhotos', 'googlePhotosV2', 'hiDrive', 'webDav', 'yandex', 'youtube', 'backblaze', 'myDrive', 'gSuite', 'evernote', 'NAS','ownCloud','sharePointOnline','mysql','egnyte','WEBDE','gmail','outlook','Icedrive'],
                ftpArr: [],
                webDav: [],
                editHomeShow: false,
                hoverCurrent: -1,
                indexCurrent: -1,
                downIndexCurrent: -1,
                cloudIndex: -1,
                cloudName: '',
                cloudId: '',
                cloud: {},
                clouds: [],
                selectItem: {},
                isflage: true,
                inputValue: '',
                oldNameValue: '',
                snapTaskIconShow: false,
                retryItems: [],
                nowCloudName:null
            }
        },
        watch: {
            '$store.state.haveNewSnapData': function (newValue, oldValue) {
                let that = this;
                //触发事件后，判断是否获取进度
                if (this.$store.state.newDataFlag && this.$store.state.loadFlag) { //说明有新数据,并且没有数据在获取进度
                    commonUtils.runDetailProgressData(that);
                }
            },
             '$store.getters.getUsersDrives':function(newValue,oldValue){
                 let that=this;
                   if (this.$store.getters.getUsersDrives.length) {
                        if(!oldValue.length){
                        this.clouds = Object.assign([], newValue);
                         this.cloudGroup(this.clouds);
                        }else{//如果含有数据，只是更新了数据
                        $.each(this.clouds,function(i,item){
                            $.each(newValue,function(j,jItem){
                                if(item.id==jItem.id){
                                    if(item.inputValue){
                                    if(item.name!=jItem.name){
                                        jItem.index=item.index;
                                        jItem.name=item.name;
                                    }
                                        jItem.inputValue=item.inputValue;
                                    }
                                }
                            })
                        });
                       this.clouds= Object.assign([],newValue);
                       this.cloudGroup(this.clouds);
                       }
                    }
            },
            //监听临时任务并根据状态将数据放在不同的tab页面
            '$store.state.detailedProgrssData': function (newValue, oldValue) {
                this.$refs.detailedProgrss.$refs.tab1.taskDatas=newValue;
            },
            '$store.state.retryItems': function () {
                this.$refs.snapTaskDialog.items = Object.assign([], this.$store.state.retryItems);
                if (this.$store.state.retryItems.length > 200) {
                    this.$store.state.retryItems.splice(201, this.$store.state.retryItems.length + 1);
                    this.$toast({
                        text: this.$t('language.cloudExploer.simultaneous'),
                        type: 'fail',
                        idValue: "rightBo"
                    });
                }
                this.retryItems = this.$refs.snapTaskDialog.items;
            },//监听上传数据，并把上传数据放在待执行任务
              '$store.state.uploadArr':function(newVale,oldValue){
                let snapData= Object.assign([], this.$store.state.retryItems);
                let uploadArr=Object.assign([], this.$store.state.uploadArr);
                this.$refs.snapTaskDialog.items =snapData.concat(uploadArr);
            },
            retryItems: function (newValue, oldValue) {
                let that = this;
                if (!newValue.length) {
                    this.$store.commit("setSourceItems", []);
                    this.selectItemArr = [];
                }
                //任务执行列表执行操作，包括刷新后界面仍有任务
                if (oldValue.length == 0) {
                    this.$nextTick(function () {
                        if (that.$store.state.loadFlag) {
                            commonUtils.runDetailProgressData(that);
                            that.$store.state.loadFlag = false;
                        }
                    });
                }
            }
        },
        created() {
           this.clouds = this.$store.getters.getUsersDrives;
           this.cloudGroup(this.clouds);
        },
        mounted() {
            let that = this;
            //初始化临时任务数据
            commonUtils.mountedDetailData(that);
        },
        methods: {

            analyzeTotalSpace(item){
                var a= 1;
                if(!item.driveInfo.totalSpace){
                    return a;
                }else{
                    a = item.driveInfo.totalSpace; 
                }
                return a;
            },
            //时间倒序排列
            sortCreateTime(a, b) {
                if (a && b)
                    return -(a.driveInfo.createTime - b.driveInfo.createTime);
            },//临时任务弹窗
            snapTasksOpen() {
               this.$store.state.snapTaskShow = ! this.$store.state.snapTaskShow;
            },//云盘分组
            cloudGroup(drives) {
                let that = this;
                that.drivesDown = [];
                that.drivesUp = [];
                that.ftpArr = [];
                that.webDav = [];
                if (drives.length) {
                    $.each(drives, function (index, item) {
                        if (that.noSpace.includes(item.appName)) {
                            that.drivesDown.push(item);
                            if (item.appName == 'FTP') {
                                that.ftpArr.push(item);
                            }
                            if (item.appName == 'webDav') {
                                that.webDav.push(item);
                            }
                        } else {
                            that.drivesUp.push(item);
                        }
                    });
                }
            },//展示基本信息
            showInfo(item) {
                let creaTime;
                let type = this.$t('language.addCloud.' + item.driveType);
                if (item.driveInfo.createTime) {
                    creaTime = commonUtils.transferTime(item.driveInfo.createTime);
                }
                let info = type + '\n' + item.name + '\n' + creaTime;
                return info;
            },//编辑云盘
            rewriteDrive() {
                this.editHomeShow = false;
                this.$refs.editCloudDialog.tipShow = false;
                //横线下方的数据
                if (this.downIndexCurrent != -1) {
                    this.$refs.editCloudDialog.inputCloudNameValue = this.drivesDown[this.downIndexCurrent].name;
                    this.$refs.editCloudDialog.cloudInfo = this.drivesDown[this.downIndexCurrent];
                    this.$refs.editCloudDialog.cloudName = this.drivesDown[this.downIndexCurrent].appName;
                    this.cloudName = this.drivesDown[this.downIndexCurrent].appName;
                    this.cloudId = this.drivesDown[this.downIndexCurrent].id;
                    if (this.drivesDown[this.downIndexCurrent].appName == "FTP") {
                        this.$refs.editFtpDialog.ftpDialog = true;
                        this.$refs.editFtpDialog.cloudInfo = this.drivesDown[this.downIndexCurrent];
                        let ftpInfo = this.drivesDown[this.downIndexCurrent].driveInfo;
                        addCloudUtils.openFtpInfo(ftpInfo,this);//打开ftp详情
                    } else if (this.drivesDown[this.downIndexCurrent].appName == "NAS") {
                         let nasInfo = this.drivesDown[this.downIndexCurrent].driveInfo;
                         addCloudUtils.openNasInfo(nasInfo,this);//打开Nas信息
                    } else {
                        this.$refs.editCloudDialog.editCloudShow = true;
                        this.$nextTick(function () {
                            addCloudUtils.getContainerHeight(this.$refs.editCloudDialog);
                        });
                    }
                    //横线上方的数据
                } else {
                    if(this.drivesUp[this.indexCurrent].appName == 'iCloudPhotos' || this.drivesUp[this.indexCurrent].appName == 'iCloudDrive'){
                        this.$refs.editCloudDialog.appleId = '';
                        this.$refs.editCloudDialog.password = '';
                    }
                    this.$refs.editCloudDialog.inputCloudNameValue = this.drivesUp[this.indexCurrent].name;
                    this.$refs.editCloudDialog.cloudInfo = this.drivesUp[this.indexCurrent];
                    this.$refs.editCloudDialog.cloudName = this.drivesUp[this.indexCurrent].appName;
                    this.cloudName = this.drivesUp[this.indexCurrent].appName;
                    this.cloudId = this.drivesUp[this.indexCurrent].id;
                    this.$refs.editCloudDialog.editCloudShow = true;
                    this.$nextTick(function () {
                        addCloudUtils.getContainerHeight(this.$refs.editCloudDialog);
                    });
                }
            },//打开云盘信息详情界面
            propertiesDialogShow() {
                let that=this;
                this.editHomeShow = false
                let getData=new addCloudUtils.getData(commonUtils.getUser().id,this.selectItem.id);
                that.Utils.doDrivesRequest("get", getData).then(res => {
                         if (res.status == 200) {
                               this.selectItem.driveInfo.totalSpace = res.drive.totalSpace;
                               this.selectItem.driveInfo.usedSpace = res.drive.usedSpace;
                                if(res.drive.email){
                                   this.selectItem.driveInfo.email=res.drive.email;
                               }
                                 if(res.drive.username){
                                   this.selectItem.driveInfo.username=res.drive.username;
                               }
                               addCloudUtils.openProperties(that,res.drive.totalSpace,res.drive.usedSpace);
                         }
                    });
            },//显示云盘右键菜单
            editDriveMenushow(event, index, item, flag) {
                this.$parent.$refs.leftBanner.editShow = false;
                item.index = index;
                item.inputValue = item.name;
                item.oldDriveName = item.name;
                this.selectItem = item;
                if (flag == 'up') {
                    this.indexCurrent = index;
                    this.downIndexCurrent = -1;
                } else {
                    this.downIndexCurrent = index;
                    this.indexCurrent = -1;
                }
                this.hoverCurrent = index;
                this.cloudIndex = index;
                let element = event.currentTarget;
                 this.editHomeShow = true;
                this.$nextTick(function () {
                    commonUtils.multipleMenuShow("editHomeMenus", event);
                })
            },//跳转到添加云盘界面
            toAddCloudPage() {
                this.$parent.$refs.leftBanner.menuOptionSelect(901);
            },//跳转到添加邮件界面
            toAddEmailPage() {
                this.$parent.$refs.leftBanner.menuOptionSelect(902);
            },// 跳转到添加云盘邮件界面
            toAddCloudEmailPage() {
                this.$parent.$refs.leftBanner.menuOptionSelect(904);
            },//获取云盘信息
            getDriveInfo(item) {
                let that = this;
                item.isRotate = true;
                that.$forceUpdate();
                let getData=new addCloudUtils.getData(commonUtils.getUser().id,item.id);
                that.Utils.doDrivesRequest('get', getData).then(res => {
                    let t = setTimeout(() => {
                        item.isRotate = false;
                        that.$forceUpdate();
                        clearTimeout(t);
                    }, 100);
                    if (res.status == 200) {
                        var afterBackup = item.driveInfo.afterBackup;
                        item.driveInfo = res.drive;
                        if(!res.drive.usedSpace){
                            item.driveInfo.usedSpace = 0;
                        }
                        if(afterBackup){
                            item.driveInfo.afterBackup = afterBackup;
                        }
                    }
                });
            },//双击跳转到云盘界面
            toCloudCatalog(item) {
                this.$store.commit('setleftbannerMenuClick', item.id);
            },//关闭右键弹窗
            editHomeMenuClose() {
                this.editHomeShow = false;
            },//删除云盘
            removeDialogShow() {
                let that = this;
                this.editHomeShow = false;
                this.cloudId = this.selectItem.id;//获取所有的任务列表
                let allTasklistData =  Object.assign([],that.$store.state.taskListArr);
                if (allTasklistData.length) {//遍历任务列表看是否有云盘在任务列表中，如果有，则弹窗提醒
                    $.each(allTasklistData, function (index, data) {
                        if (!data.sources) {
                            if (data.fromItem.driveId == that.cloudId || data.toItem.driveId == that.cloudId) {
                                that.$refs.removeDialog.removeShow = true;
                                return false;
                            }
                        } else if (data.sources) {
                            $.each(data.sources, function (m, item) {
                                if (data.fromItem.driveId == that.cloudId || data.toItem.driveId == that.cloudId || item.fromItem.driveId == that.cloudId || item.toItem.driveId == that.cloudId) {
                                    that.$refs.removeDialog.removeShow = true;
                                    return false;
                                }
                            });
                        }//如果遍历完毕没有云盘的任务则进行删除
                        if (index == allTasklistData.length - 1 && !that.$refs.removeDialog.removeShow) {
                            addCloudUtils.deletePage(that.cloudId,that);
                        }
                    });
                } else {//如果任务列表为空则直接删除
                    addCloudUtils.deletePage(that.cloudId,that);
                }
            },//在主页取消上传任务
            cancelUpload: function (data) {
                let that = this;
                if (commonstate.source) {
                    commonstate.source.cancel('取消上传' + data);
                }
            },
            //删除云盘成功的后续操作
            deleCloudSuccess() {
                let that = this;
                let cloudId = this.selectItem.id;
                taskListUtils.delteHavaTask(that.cloudId);//删除任务列表
                if (this.indexCurrent != -1) {
                    this.drivesUp.splice(this.indexCurrent, 1);//移除云盘
                } else if (this.downIndexCurrent != -1) {
                    this.drivesDown.splice(this.downIndexCurrent, 1);//移除云盘
                }
                let allClous = Object.assign([], this.$store.getters.getUsersDrives);//移除缓存中的云盘
                $.each(allClous, function (cIindex, cItem) {
                    if (cItem.id == cloudId) {
                        allClous.splice(cIindex, 1);
                        that.$store.commit("setUsersDrives", allClous);
                        that.clouds = Object.assign([], that.$store.getters.getUsersDrives);
                        that.$parent.$refs.leftBanner.clouds = that.clouds;
                        if (allClous.length == 0) {
                            that.$parent.$refs.leftBanner.menuOptionSelect(904);
                        }
                        return false;
                    }
                });
                return true;
            },
            editDriveName() {//编辑任务名
                this.editHomeShow = false;
                this.editInputStyle("block", "none", this.selectItem);
            },//更改输入框的样式
            editInputStyle(inputDomStye, divDomStyle, cloud) {
                let inputDom;
                let divDom;
                if (this.indexCurrent != -1) {
                    let inputName = 'inputName' + cloud.index;
                    let driveName = 'driveName' + cloud.index;
                    inputDom = this.$refs.inputName[cloud.index];
                    divDom = this.$refs.driveName[cloud.index];
                } else {
                    let inputName = 'inputDownName' + cloud.index;
                    let driveName = 'driveDownName' + cloud.index;
                    inputDom = this.$refs.inputDownName[cloud.index];
                    divDom = this.$refs.driveDownName[cloud.index];
                }
                inputDom.style.display = inputDomStye;
                divDom.style.display = divDomStyle;
                inputDom.children[0].select();
            },
            cancelEditDriveName(item, index) {//取消编辑任务名
                this.isflage = false;
                this.editInputStyle("none", "block", item);
            },
            submitDriveName(item, index) {//提交云盘名
                let that = this;
                if (this.isflage) {
                    let renameData=new addCloudUtils.renameDrive(commonUtils.getUser().id,item.id,item.inputValue);
                    if (item.inputValue.length > 200) {//如果任务名称大于200
                        that.$toast({
                            text: that.$t('language.home.cloudDiskName'),
                            type: 'fail',
                            idValue: "home"
                        });
                        that.cancelEditDriveName(item, index);
                        return false;
                    }//如果云盘名含有特殊字符
                    if (commonstate.patternDriveName.test(item.inputValue)) {
                        that.$toast({
                            text: that.$t('language.home.driveNameNotContain'),
                            type: 'fail',
                            idValue: "leftBan",
                        });
                        that.cancelEditDriveName(item, index);
                        return false;
                    }//如果云盘新名字等于旧名字，则取消编辑
                    if (item.inputValue == item.oldDriveName) {
                        that.cancelEditDriveName(item, index);
                        return false;
                    }//重命名请求
                    this.nowCloudName=item.inputValue;
                    if(!item.haveLoad){//如果还未来得及取得返回数据
                         item.name=item.inputValue;
                         that.editInputStyle("none", "block", item);//还原编辑样式
                         $.each(that.$parent.$refs.leftBanner.clouds, function (index, item2) {
                                if (item2.id == item.id) {
                                    item2.name = item.inputValue;
                                    return;
                                }
                            });
                    }
                    this.Utils.doDrivesRequest("rename", renameData).then(res => {
                        if (res.status == 200) {
                            if(item.haveLoad){
                            item.name=res.drive.name;
                            that.editInputStyle("none", "block", item);//还原编辑样式
                            $.each(that.$parent.$refs.leftBanner.clouds, function (index, item2) {
                                if (item2.id == item.id) {
                                    item2.name = res.drive.name;
                                    return;
                                }
                            });
                            }
                        } else {
                            that.$toast({
                                text: that.$t('language.exception.' + res.reason),
                                type: 'fail',
                                idValue: "home"
                            });
                        }
                    });
                }
            }
        },
    }
    </script>
    
    <style>
    #home .hr {
        clear: left;
        width: 95%;
        height: 1px;
        /*no*/
        background-color: #f1f1f1;
        margin-left: 20px;
        /*no*/
    }
    
    .cloud-position {
        position: relative;
        height: 30px;
        /*no*/
        margin-top: 5px;
        /*no*/
    }
    
    .rotate1 {
        transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        /* IE 9 */
        -moz-transform: rotate(360deg);
        /* Firefox */
        -webkit-transform: rotate(360deg);
        /* Safari 和 Chrome */
        -o-transform: rotate(360deg);
        /* Opera */
        transition: all 1s;
    }
    
    .home-box {
        width: 96%;
        height: 96%;
        background-color: #fff;
        margin: 0% 2% 0% 2%;
        border: 1px solid #d6e4f7;
        /*no*/
        box-sizing: border-box;
        overflow-y: auto;
    
    }
    
    .home-cloud-position {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 20px;
        /*no*/
        height: 20px;
        /*no*/
    }
    
    .cloud-box {
        width: 22.8%;
        height: 60px;
        /*no*/
        border: 1px solid #fff;
        /*no*/
        float: left;
        margin: 10px 0px 4px 20px;
        /*no*/
        cursor: pointer;
    }
    
    .cloud-box:hover,
    .home-cloud:hover {
        border: 1px solid #a9baff;
        /*no*/
        background: #eDf3fb;
    }
    
    .cloud-click {
        border: 1px solid #a9baff;
        /*no*/
        background: #d9e7ff !important;
    }
    
    .home-middle {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: fit-content;
    }
    
    .home-button {
        margin-right: 10Px;
        line-height: 30px;/*no*/
        display: flex;
    }
    
    .home-button .icon{
        margin-right: 5px;/*no*/
        margin-top: 4px;/*no*/
    }
    
    .cloud-box-left {
        width: 16%;
        height: 100%;
        float: left;
        position: relative;
    }
    
    .cloud-box-right {
        width: 84%;
        height: 100%;
        float: right;
        position: relative;
    }
    
    .right-info {
        width: 100%;
        height: 65px;
        /*no*/
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
    
    .drive-bold-name {
        font-weight: bold;
        float: left;
        width: calc(100% - 20px);
        /*no*/
        height: 25px;
        /*no*/
        line-height: 30px;
        /*no*/
        font-size: 12px;
        /*no*/
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    .drive-progrss-box {
        width: calc(100% - 25px);
        /*no*/
        height: 14px;
        /*no*/
        border: 1px solid #a9baff;
        /*no*/
        padding: 1px;
        /*no*/
        box-sizing: border-box;
        float: left;
    }
    
    .drive-progrss {
        height: 100%;
        background: #5166bd;
        max-width: 100%;
        width: 0;
    }
    
    .drive-red-progress {
        height: 100%;
        background: #dc1f06;
        max-width: 100%;
    }
    
    .drive-capacity {
        font-size: 12px;
        /*no*/
        color: #222;
        margin-top: 5px;
        /*no*/
        float: left;
        width: 100%;
    }
    
    .home-refresh-position {
        float: right;
        margin: 2px 2px;
        /*no*/
        display: none;
        position: absolute;
        z-index: 3;
        right: 0;
    }
    
    .cloud-box:hover .home-refresh-position {
        float: right;
        margin: 2px 2px;
        /*no*/
        display: block;
        position: absolute;
        z-index: 3;
        right: 0;
    }
    
    .drive-down {
        position: relative;
        width: 100%
    }
    
    .drive-down-name {
        font-size: 12Px;
        color: #222;
        max-width: 130Px;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        margin: auto;
    }
    
    .name-outer {
        height: 25px;
        /*no*/
        width: 100%;
        position: relative;
    }

    .right-cont-body-home {
        height: 100%;
    }
    </style>
    


// WEBPACK FOOTER //
// src/components/workspace/home.vue